/* @ngInject */
const test = (
  valueHandler,
  utils
) => {
  const self = {}

  self.getRevisionDateEnd = (_revisionDate, _step, _extendRevision) => {
    if (!_revisionDate) return
    const date = utils.date.timestampToDate(_revisionDate)
    if (_extendRevision) {
      date.month(date.month() + _extendRevision)
    }
    date.year(date.year() + _step)
    return date
  }

  self.getRevisionColor = (_revisionDate, _step, _extendRevision) => {
    if (!_revisionDate) return

    const date = self.getRevisionDateEnd(_revisionDate, _step, _extendRevision)
    const today = utils.date.getToday()

    if (today.isAfter(date.clone().add(5, 'years'))) {
      return 'badge-revision-4'
    } else if (today.isAfter(date.clone().add(6, 'months'))) {
      return 'badge-revision-3'
    } else if (today.isAfter(date)) {
      return 'badge-revision-2'
    } else if (today.isAfter(date.clone().subtract(6, 'months'))) {
      return 'badge-revision-1'
    }
  }

  self.isRevisionOk = (_revisionDate, _step, _extendRevision) => {
    if (valueHandler.isEmpty(_revisionDate) || valueHandler.isEmpty(_step)) {
      return true
    }
    if (valueHandler.isEmpty(_extendRevision)) {
      _extendRevision = false
    }

    const date = self.getRevisionDateEnd(_revisionDate, _step, _extendRevision)
    const today = utils.date.getToday()
    if (today.isBefore(date.subtract(6, 'months'))) {
      return true
    }
    return false
  }

  self.isDateTrainOk = (_arrivalDate) => {
    if (valueHandler.isEmpty(_arrivalDate)) {
      return true
    }

    const date = utils.date.timestampToDate(_arrivalDate)
    date.month(date.month() + 6)

    const today = utils.date.getToday()
    if (today.isBefore(date)) {
      return true
    }
    return false
  }

  return self
}
export default test



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/trains/wagon/services/test.service.js